import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { AircraftType } from '@ogn-tracker/common/build/enum/aircraft-type';
import { VehiclesQuery } from 'src/app/store/vehicles/state/vehicles.query';
import { VehiclesStore, VehiclesState } from 'src/app/store/vehicles/state/vehicles.store';
import { SubSink } from 'subsink';
type VehiclesCheckBox = Record<keyof VehiclesState, FormControl>;

@Component({
  selector: 'app-vehicles',
  templateUrl: './vehicles.component.html',
  styleUrls: ['./vehicles.component.scss'],
})
export class VehiclesComponent implements OnInit, OnDestroy {
  constructor(private store: VehiclesStore, private query: VehiclesQuery) {}
  AircraftType = AircraftType
  formControls: VehiclesCheckBox = {
    ...Object.entries(this.query.getValue()).reduce((acc,[key, value]) => {
      acc[key] = new FormControl(value)
      return acc;
    }, {} as VehiclesCheckBox)
  };

  vehiclesFormGroup = new FormGroup(this.formControls);
  subs = new SubSink();
  ngOnInit(): void {
    this.subs.sink = this.vehiclesFormGroup.valueChanges.subscribe((x) =>
      this.store.update(x)
    );
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }
}
